import Vue from 'vue'
import { callTurnToConfigFn, encodeArray } from 'util/turnto-utils'
import domUtils from 'util/dom-utils'
import getCatalogItemsForCommentsPinboardService from 'services/api/get-catalog-items-for-comments-pinboard'
import pinboardConfig from 'widgets/comments-pinboard/comments-pinboard.config'
import pinboardStore from 'store/comments-pinboard-store'
import MasonryLayout from 'layouts/masonry/layout'
import PinboardItem from 'components/pinboard/comments-pinboard-item'

import withRender from './comments-pinboard.html'
import './comments-pinboard.scss'

export default withRender(Vue.extend({
  data() {
    return {
      hasMore: true,
      isLoading: false,
      items: [],
      offset: 0,
      pinboardStore
    }
  },
  components: {
    'tt-masonry-layout': MasonryLayout,
    'tt-pinboard-item': PinboardItem
  },
  computed: {
    currentFilters() {
      return {
        skus: this.pinboardStore.skus,
        tags: this.pinboardStore.tags,
        brands: this.pinboardStore.brands
      }
    },
    displayShowMoreButton() {
      return !pinboardConfig.progressiveLoading && !this.isLoading &&
        this.offset > 0 && this.hasMore
    },
    displayShowMoreWrapper() {
      return this.items.length > 0 && (this.displayShowMoreButton || this.isLoading)
    },
    pinboardConfig() {
      return pinboardConfig
    },
    useProgressiveLoading() { // for MasonryLayout.  If true, it will handle scroll event
      return this.hasMore && pinboardConfig.progressiveLoading && !this.isLoading
    }
  },
  methods: {
    doneLoading() { // called when MasonryLayout is done positioning tiles that were loaded
      this.isLoading = false
    },
    fetchData() {
      if (this.hasMore && !this.isLoading) {
        this.isLoading = true
        getCatalogItemsForCommentsPinboardService.getCatalogItemsForCommentsPinboard({
          offset: this.offset,
          limit: pinboardConfig.limit,
          activeOnly: pinboardConfig.activeOnly,
          brands: encodeArray(pinboardStore.brands),
          skus: encodeArray(pinboardStore.skus),
          tags: encodeArray(pinboardStore.tags),
          includeCommentsCount: false,
          includeReviewData: pinboardConfig.showReviewStars,
          maxDaysOld: pinboardConfig.maxDaysOld,
          includeSyndicated: pinboardConfig.includeSyndicated,
          minComments: 1,
          maxCommentsReturned: pinboardConfig.maxCommentsReturned
        }).then((data) => {
          if (data.catalogItems.length === 0) {
            // if there are items the MasonryLayout will call this.doneLoading() to set to false
            this.isLoading = false
          }
          // grabbing the last few ids to make sure we don't put a dup item in from this batch.
          // this can happen when an item gets mediated out in between page loads.  Yes, unlikely,
          // but happened in prod with previous version causing some layout issues.
          const ids = this.items.slice(-10).map(item => item.id)
          data.catalogItems.forEach((item, i) => {
            if (!~ids.indexOf(item.id)) {
              this.items.push(item)
            }
          })
          this.hasMore = data.hasMore
          this.$nextTick(() => {
            domUtils.whenRefIsVisible(this.$refs, 'layout').then(() => {
              // notify the layout that tiles have been added
              this.$refs.layout.$emit('tilesAdded')
            })
          })
          // only called on first load
          if (this.offset === 0) {
            // waiting for pinboard to finish loading before attempting to call onFinish
            this.$nextTick(() => { callTurnToConfigFn('commentsPinboard', 'onFinish') })
          }
          this.offset += data.catalogItems.length
        }).catch(() => this.isLoading = false)
      }
    },
    showMore() {
      this.fetchData()
    }
  },
  watch: {
    // whenever one of the filters changes (skus, tags, or brands), we need to reload the pinboard
    currentFilters: {
      handler() {
        this.offset = 0
        this.hasMore = true
        this.items = []
        this.fetchData()
      },
      deep: true
    }
  },
  created() {
    this.fetchData()
  }
}))
